import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { handleGetProjects } from './projectThunk';
import { IProjects } from '~/utils/interface/project';
import { StatusMode } from '~/utils/types/common';

type StatusModeState = StatusMode | 'all';
type SortParams = {
  field: string;
  type: 'ASC' | 'DESC';
};

export interface ProjectState {
  projects: Array<IProjects>;
  countsJobPerStatusMode: {
    all: number;
    progress: number;
    hold: number;
    completed: number;
    [key: string]: number;
  };
  sortBy: Array<SortParams>;
  searchInput: string;
  statusMode: StatusModeState;
  totalPages: number;
  project_dummy: any
}

const initialState: ProjectState = {
  projects: [],
  countsJobPerStatusMode: {
    all: 0,
    progress: 0,
    hold: 0,
    completed: 0,
  },
  sortBy: [],
  searchInput: '',
  statusMode: 'all',
  totalPages: 0,
  project_dummy: [
    {
      id: 1,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 2,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2024-01-20',
    },
    {
      id: 3,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-10',
    },
    {
      id: 4,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2029-01-25',
    },
    {
      id: 5,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 6,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 7,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 8,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 9,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 10,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 11,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 12,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 13,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
    {
      id: 14,
      client_name: 'Client Name',
      project_name: 'Project Name',
      country: 'England',
      phone_number: '012-3456789',
      email: 'example@gmail.com',
      status: 'completed',
      date: '2019-01-25',
    },
  ]
};

const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    changeStatusMode(state, action: PayloadAction<StatusModeState>) {
      state.statusMode = action.payload;
    },
    changeSearchInput(state, action: PayloadAction<string>) {
      state.searchInput = action.payload;
    },

    // only use single sort, multiple sort will be implement next time
    changeSortBy(state, action: PayloadAction<SortParams>) {
      state.sortBy = [action.payload];
    },
  },
  extraReducers(builder) {
    builder
      .addCase(handleGetProjects.pending, (state, action) => {})
      .addCase(handleGetProjects.fulfilled, (state, action) => {
        state.projects = [...action.payload.responses];
        state.countsJobPerStatusMode = {
          all: action.payload.countAll,
          progress: action.payload.countInProgress,
          hold: action.payload.countHold,
          completed: action.payload.countCompleted,
        };
        state.totalPages = action.payload.pagination.totalPages;
      })
      .addCase(handleGetProjects.rejected, (state, action) => {});
  },
});

export const projectActions = projectSlice.actions;

const projectReducer = projectSlice.reducer;
export default projectReducer;
